module.exports = __webpack_public_path__ + "static/media/web-app-icon.def2fd25.svg";